import { __read } from "tslib";
import React, { useRef, useState, useLayoutEffect } from 'react';
import { useClickAway } from 'react-use';
import { Portal } from '../Portal/Portal';
import { Menu } from '../Menu/Menu';
export var ContextMenu = React.memo(function (_a) {
    var x = _a.x, y = _a.y, onClose = _a.onClose, items = _a.items, renderHeader = _a.renderHeader;
    var menuRef = useRef(null);
    var _b = __read(useState({}), 2), positionStyles = _b[0], setPositionStyles = _b[1];
    useLayoutEffect(function () {
        var menuElement = menuRef.current;
        if (menuElement) {
            var rect = menuElement.getBoundingClientRect();
            var OFFSET = 5;
            var collisions = {
                right: window.innerWidth < x + rect.width,
                bottom: window.innerHeight < rect.bottom + rect.height + OFFSET,
            };
            setPositionStyles({
                position: 'fixed',
                left: collisions.right ? x - rect.width - OFFSET : x - OFFSET,
                top: collisions.bottom ? y - rect.height - OFFSET : y + OFFSET,
            });
        }
    }, [x, y]);
    useClickAway(menuRef, function () {
        if (onClose) {
            onClose();
        }
    });
    var header = renderHeader && renderHeader();
    return (React.createElement(Portal, null,
        React.createElement(Menu, { header: header, items: items, onClose: onClose, ref: menuRef, style: positionStyles })));
});
ContextMenu.displayName = 'ContextMenu';
//# sourceMappingURL=ContextMenu.js.map